module.exports = __webpack_public_path__ + "87af7cb84fd76ccadb833df27b850a9c.woff";